import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';

import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { LoaderService } from './../../core/loader.service';
import { AuthServiceCleaner } from './../../shared/services/auth.service.cleaner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-end-session',
  templateUrl: './end-session.component.html',
  styleUrls: ['./end-session.component.sass'],
})
export class EndSessionComponent implements OnInit {
  constructor(
    private loaderService: LoaderService,
    private authService: AuthenticationService,
    private authClearService: AuthServiceCleaner,
    private router: Router
  ) {}

  ngOnInit() {
    this.loaderService.showMain = false;
    //this.authService.signoutRedirect();
    this.authClearService.SetLogoutEvent();

    // this.authService.getCurrentUser().subscribe({
    //   next: (user) => {
    //     if (user) {
    //       this.authClearService.SetLogoutEvent();
    //     } else {
    //       this.authService.removeIndexedDbItem().then(() => {
    //         window.localStorage.clear();
    //         this.authService.signoutRedirect();
    //       });
    //     }
    //   },
    //   error: (e) => {
    //     console.log(e);
    //     this.loaderService.showMain = false;
    //     this.router.navigate(['/oops']);
    //   },
    // });
  }
}
